import Styles from './DesignWizardField.module.scss'
import { PropsWithChildren, ReactNode } from 'react'
import { Button } from 'blaze-ui/Button'
import { Text } from 'blaze-ui/Text/Text'
import cx from 'classnames'
import { Plus } from 'screens/BrandKits/components/NewBrandAICard/NewBrandAICard'
import { PressableBrandAICard } from 'screens/BrandKits/components/BrandAICard/BrandAICard'
import { Icon } from 'blaze-ui/icons/Types'

interface Props {
  title: string
  onButtonPress?: () => void
  buttonLabel?: string
  buttonIcon?: Icon
  isEmpty?: boolean
  emptyIcon?: ReactNode
  emptyLabel?: string
  onPress?: () => void
  className?: string
  withChecklist?: boolean
}

export const DesignWizardField = ({
  title,
  onButtonPress,
  children,
  buttonLabel,
  buttonIcon: Icon,
  isEmpty = false,
  emptyIcon,
  emptyLabel,
  onPress,
  className,
  withChecklist = false,
}: PropsWithChildren<Props>) => {
  return (
    <div className={cx(Styles.fieldContainer, className, { [Styles.isEmpty]: isEmpty })}>
      <div className={Styles.previewAndTitle}>
        <Text variant="placeholder" color="var(--dark-80)">
          {title}
        </Text>
        {isEmpty ? (
          <PressableBrandAICard
            onPress={onPress}
            size="lg"
            preview={() => (
              <div className={Styles.emptyState}>
                <div className={Styles.icon}>
                  {emptyIcon}
                  <div className={Styles.plus}>
                    <Plus />
                  </div>
                </div>
                <div className={Styles.label}>
                  <Text variant="smallList" color="var(--dark-80)">
                    {emptyLabel}
                  </Text>
                </div>
              </div>
            )}
          />
        ) : (
          <div className={cx(Styles.fieldCard, { [Styles.withChecklist]: withChecklist })}>
            {children}

            {!!buttonLabel && (
              <div className={Styles.actionButton}>
                <Button size="sm" fullWidth frontIcon={Icon} variant="tertiary" onPress={onButtonPress}>
                  {buttonLabel}
                </Button>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  )
}
